import React from 'react'
import PropTypes from 'prop-types'
import Banner from './components/Banner'
import { List, ListItem, CustomLink, Description, Wrapper } from '../../Shared.styles'

const BOTLocation = ({ title, image, description, states = []}) =>
  <Wrapper>
    <Banner title={ title } image={ image } />
    <Description>{ description }</Description>
    <List>
      { states.map(place =>
        <ListItem key={ place.stateName }>
          <CustomLink to={ place.stateDetailsUrl }>{ place.stateName }</CustomLink>
        </ListItem>
      )}
    </List>
  </Wrapper>

BOTLocation.propTypes = {
  description: PropTypes.string,
  image: PropTypes.string,
  states: PropTypes.arrayOf(PropTypes.shape()),
  title: PropTypes.string
}

export default BOTLocation
